import { Link } from "react-router-dom";
import { footerWorkLinks, navItems, siteIntro, socialLinks } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-50 mt-auto">
      <div className="px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center text-lg font-heading font-bold">
                佳
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-lg font-bold text-background-50">森泽佳奈</span>
                <span className="text-xs text-background-300 tracking-[0.2em] uppercase">
                  Official Site
                </span>
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              {siteIntro.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">导航</h4>
            <ul className="flex flex-col gap-2">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">作品分类</h4>
            <ul className="flex flex-col gap-2">
              {footerWorkLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关注动态</h4>
            <p className="text-sm text-background-300 mb-4 leading-relaxed">
              通过官方渠道第一时间获取最新资讯与活动信息。
            </p>
            <div className="flex items-center gap-2 flex-wrap">
              {socialLinks.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  title={s.name}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-800 text-background-100 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-primary-800 mt-8 md:mt-10 pt-6">
          <p className="text-xs text-background-400">
            © {year} 森泽佳奈 个人品牌官方网站 · 本站为演示示例，内容均为虚构，请勿用于商业用途。
          </p>
          <p className="text-xs text-background-400">
            Designed for fans, media &amp; art lovers
          </p>
        </div>
      </div>
    </footer>
  );
}